import { useQuery } from "@tanstack/react-query";
import { createUrlWithQuery } from "../../../hooks/utils";
import { apiClient } from "../../../services/Services";

// Utility: arrayBufferToBase64 (copied from utils.js)
function arrayBufferToBase64(buffer: ArrayBuffer): string {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
}

export interface VideoImageResult {
    videoId: string;
    imageUrl: string | null;
}

export function useFetchVideoImage(videoId?: string) {
    return useQuery<string>({
        queryKey: ["video-image", videoId],
        queryFn: async (): Promise<string> => {
            const response = await apiClient.get<ArrayBuffer>(
                createUrlWithQuery(`/videos/${videoId}/frames`, {
                    offset: 0,
                }),
                {
                    responseType: "arraybuffer",
                    headers: { Accept: "image/jpeg" },
                },
            );
            const base64 = arrayBufferToBase64(response as ArrayBuffer);
            const imageUrl = `data:image/jpeg;base64,${base64}`;
            return imageUrl;
        },
        enabled: !!videoId,
    });
}
